import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import IosShareIcon from '@mui/icons-material/IosShare';
import HelpIcon from '@mui/icons-material/Help';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const actions = [
  { icon: <HelpIcon />, name: 'Ask A Question' },
  { icon: <IosShareIcon />, name: 'Share' },
];

export default function ShowSpeedDialVisitor({post}) {
  return (
    <Box sx={{ height: 100, transform: 'translateZ(0px)', flexGrow: 1 }}>
      <SpeedDial
        ariaLabel="Post SpeedDial"
        sx={{ position: 'absolute', bottom: 10, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          key="Make An Offer"
          icon={<Link 
                to="/addOffer" 
                state={{post}}
                style={{ textDecoration: 'none', color: 'white' }}>
                <ShoppingCartIcon/></Link>}
          tooltipTitle="Make An Offer"
        />
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
          />
        ))}
      </SpeedDial>
    </Box>
  );
}
